var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvaxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#E84142;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 168.5,
    y: 151.3,
    className: "st0",
    width: 544.5,
    height: 495.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M881.6,441.2c0,243.3-197.3,440.6-440.6,440.6C197.6,881.8,0.4,684.5,0.4,441.2C0.4,197.8,197.6,0.6,441,0.6 C684.3,0.6,881.6,197.8,881.6,441.2z M316.1,616.5h-85.5c-18,0-26.8,0-32.3-3.5c-5.8-3.8-9.4-10.1-9.9-17 c-0.3-6.4,4.1-14.2,13-29.8l211.1-372.2c9-15.8,13.5-23.7,19.3-26.6c6.2-3.1,13.5-3.1,19.7,0c5.7,2.9,10.3,10.8,19.3,26.6 l43.4,75.8l0.2,0.4c9.7,17,14.6,25.6,16.8,34.6c2.4,9.9,2.4,20.2,0,30.1c-2.2,9.1-7,17.8-16.9,35L403.5,566l-0.3,0.5 c-9.8,17.1-14.7,25.8-21.6,32.3c-7.5,7.1-16.5,12.3-26.3,15.3C346.3,616.5,336.3,616.5,316.1,616.5z M532.1,616.5h122.5 c18.1,0,27.2,0,32.6-3.6c5.8-3.8,9.5-10.2,9.9-17.1c0.3-6.2-4-13.7-12.5-28.4c-0.3-0.5-0.6-1-0.9-1.5l-61.4-105l-0.7-1.2 c-8.6-14.6-13-21.9-18.6-24.8c-6.2-3.1-13.4-3.1-19.6,0c-5.6,2.9-10.2,10.6-19.2,26.1l-61.2,105l-0.2,0.4 c-9,15.5-13.4,23.2-13.1,29.5c0.4,6.9,4,13.3,9.8,17.1C504.9,616.5,514,616.5,532.1,616.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaxIcon);
export default __webpack_public_path__ + "static/media/avax_icon.0822b638e2919cc9cd41a389d456d7fa.svg";
export { ForwardRef as ReactComponent };